/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_ScanningInputs */

const en_portal_scanner_scanning = /** @type {(inputs: Portal_Scanner_ScanningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanning...`)
};

const de_portal_scanner_scanning = /** @type {(inputs: Portal_Scanner_ScanningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanning...`)
};

const fr_portal_scanner_scanning = /** @type {(inputs: Portal_Scanner_ScanningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanning...`)
};

const es_portal_scanner_scanning = /** @type {(inputs: Portal_Scanner_ScanningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanning...`)
};

const it_portal_scanner_scanning = /** @type {(inputs: Portal_Scanner_ScanningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanning...`)
};

const nl_portal_scanner_scanning = /** @type {(inputs: Portal_Scanner_ScanningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanning...`)
};

const pl_portal_scanner_scanning = /** @type {(inputs: Portal_Scanner_ScanningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanning...`)
};

const fi_portal_scanner_scanning = /** @type {(inputs: Portal_Scanner_ScanningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanning...`)
};

const da_portal_scanner_scanning = /** @type {(inputs: Portal_Scanner_ScanningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanning...`)
};

const sv_portal_scanner_scanning = /** @type {(inputs: Portal_Scanner_ScanningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanning...`)
};

/**
* | output |
* | --- |
* | "Scanning..." |
*
* @param {Portal_Scanner_ScanningInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_scanning = /** @type {((inputs?: Portal_Scanner_ScanningInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_ScanningInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_scanning(inputs)
	if (locale === "fr") return fr_portal_scanner_scanning(inputs)
	if (locale === "es") return es_portal_scanner_scanning(inputs)
	if (locale === "it") return it_portal_scanner_scanning(inputs)
	if (locale === "nl") return nl_portal_scanner_scanning(inputs)
	if (locale === "pl") return pl_portal_scanner_scanning(inputs)
	if (locale === "fi") return fi_portal_scanner_scanning(inputs)
	if (locale === "da") return da_portal_scanner_scanning(inputs)
	if (locale === "sv") return sv_portal_scanner_scanning(inputs)
	return en_portal_scanner_scanning(inputs)
});